module.exports = __webpack_public_path__ + "static/media/multiple_zones.8a8bdf3f.png";